// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
var __webpack_exports__ = __webpack_require__("./wp-content/themes/cossette/assets/ts/main.ts");
